import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { HomeComponent } from './home/home/home.component';
import { DashboardHomeComponent } from './dashboard/dashboard/dashboard.component';
import { AuthGuard } from './auth.guard';
import { AuthorizedGuard } from "libs/auth/src/lib/services/auth-guard.service";

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
	{path: 'auth',
	loadChildren: () => import('@cradua/auth').then(m => m.AuthModule)
   },
   {path: 'pipelinelicence',
  loadChildren: () => import('@cradua/pipelinelicence').then(m => m.PipelinelicenceModule),canActivate: [AuthGuard, AuthorizedGuard],

   },
   {path: 'dashboard',
	loadChildren: () => import('@cradua/dashboard').then(m => m.DashboardModule),canActivate: [AuthGuard]
   },
   {path:'dashboard2', component: DashboardHomeComponent,canActivate: [AuthGuard]},
   {
		path: 'home',
		component: HomeComponent, pathMatch: 'full'
  },
 
  {
    path: "damageassessmentreport",
    loadChildren: () =>
      import("@cradua/reports").then((m) => m.ReportsModule),canActivate: [AuthGuard]
  },
  {
    path: "staffregister",
    loadChildren: () =>
      import("@cradua/staffregister").then((m) => m.StaffregisterModule),canActivate: [AuthGuard, AuthorizedGuard]
  },

  {
    path: "damageassessment",
    loadChildren: () =>
      import("@cradua/damageassessment").then((m) => m.DamageassessmentModule),canActivate: [AuthGuard, AuthorizedGuard]
  },
  {
    path: "adr-progress",
    loadChildren: () =>
      import("@cradua/adr-progress").then((m) => m.AdrProgressModule),canActivate: [AuthGuard]
  },
  {
    path: "audittray",
    loadChildren: () =>
      import("@cradua/audittray").then((m) => m.AudittrayModule),canActivate: [AuthGuard]
  },
  {
    path: 'stakeholderresponse',
    loadChildren: () =>
      import('@cradua/stakeholderresponse').then(
        (m) => m.StakeholderResponseModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "encroachment",
    loadChildren: () =>
      import("@cradua/encroachment").then((m) => m.EncroachmentModule),canActivate: [AuthGuard]
  },
   {
    path: "references",
    loadChildren: () =>
      import("@cradua/epims-references").then((m) => m.EpimsReferencesModule),canActivate: [AuthGuard]
  },
  {
    path: "scholarship",
    loadChildren: () =>
      import("@cradua/scholarship-management").then(
        (m) => m.ScholarshipManagementModule,
      ),canActivate: [AuthGuard]
  },
  {
    path: "project",
    loadChildren: () =>
      import("@cradua/project-management").then(
        (m) => m.ProjectManagementModule,
      ),canActivate: [AuthGuard]
  },
  {
    path: "stakeholderreference",
    loadChildren: () =>
      import("@cradua/stakeholderreference").then(
        (m) => m.StakeholderreferenceModule,
      ),canActivate: [AuthGuard]
  },
  {
    path: "stakeholder",
    loadChildren: () =>
      import("@cradua/stakeholder").then((m) => m.StakeholderModule),canActivate: [AuthGuard]
  },
  {
    path: "documents",
    loadChildren: () =>
      import("@cradua/documentoperations").then(
        (m) => m.DocumentoperationsModule,
      ),canActivate: [AuthGuard]
  },
  {
    path: "incident",
    loadChildren: () =>
      import("@cradua/incident").then((m) => m.IncidentModule),canActivate: [AuthGuard, AuthorizedGuard]
  },
  {
    path: "correspondence",
    loadChildren: () =>
      import("@cradua/correspondence-management").then(
        (m) => m.CorrespondenceManagementModule,
      ),canActivate: [AuthGuard, AuthorizedGuard]
  },
  {
    path: "acquisition",
    loadChildren: async () =>
      (await import("@cradua/acquisition")).AcquisitionModule,canActivate: [AuthGuard, AuthorizedGuard]
  },
  {
    path: "document",
    loadChildren: () =>
      import("@cradua/generic-document").then((m) => m.GenericDocumentModule),canActivate: [AuthGuard]
  },
  {
    path: "adr",
    loadChildren: () =>
      import("@cradua/adr-management").then((m) => m.AdrManagementModule),canActivate: [AuthGuard, AuthorizedGuard]
  },
  {
    path: "taskactions",
    loadChildren: () =>
      import("@cradua/taskactions").then((m) => m.TaskactionsModule),canActivate: [AuthGuard, AuthorizedGuard]
  },
  {
    path: "incident",
    loadChildren: () =>
      import("@cradua/incident").then((m) => m.IncidentModule),canActivate: [AuthGuard]
  },
  {
    path: "rights-obligations",
    loadChildren: async () =>
      (await import("@cradua/rights-obligations")).RightsObligationsModule,canActivate: [AuthGuard]
  },
  {
    path: "pipeline",
    loadChildren: () =>
      import("@cradua/pipeline").then(
        (m) => m.PipelineModule,
      ),canActivate: [AuthGuard, AuthorizedGuard]
  },
  {
    path: "roles",
    loadChildren: () =>
      import("@cradua/roles").then(
        (m) => m.RoleModule,
      )
  },
  {
    path: "staffroles",
    loadChildren: () =>
      import("@cradua/staffroles").then(
        (m) => m.StaffRoleModule,
      ),canActivate: [AuthGuard]
  },
  {
    path: "approval",
    loadChildren: () =>
      import("@cradua/seismicapproval").then(
        (m) => m.SeismicapprovalModule,
      ),canActivate: [AuthGuard, AuthorizedGuard]
  },

  {
    path: "supervisor",
    loadChildren: () =>
      import("@cradua/supervisor").then(
        (m) => m.SupervisorModule,
      ),canActivate: [AuthGuard]
  },

  {
    path: "seismiccontractor",
    loadChildren: () =>
      import("@cradua/contractor").then(
        (m) => m.ContractorModule,
      ),canActivate: [AuthGuard]
  },
  {
    path: "reports",
    loadChildren: () =>
      import("@cradua/reports").then(
        (m) => m.ReportsModule,
      ),canActivate: [AuthGuard]
  },
  {
    path: "incident-response",
    loadChildren: () =>
      import("@cradua/safety").then(
        (m) => m.SafetyModule,
      ),canActivate: [AuthGuard]
  },
  {
    path: "request",
    loadChildren: () =>
      import("@cradua/request-management").then(
        (m) => m.RequestManagementModule,
      )
  },
  {
    path: "incidentregister",
    loadChildren: () =>
      import("@cradua/incidentregister").then(
        (m) => m.IncidentregisterModule,
      )
  },


  { path: '**', component: HomeComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: "enabled",
      preloadingStrategy: PreloadAllModules,
      initialNavigation: "enabled",
    }),
  ],

  exports: [RouterModule],
})
export class AppRoutingModule {}
